import { Link, NavLink, useLocation } from "react-router-dom";
import { Logo } from "./Logo";
import { trackCta } from "../lib/analytics";

// Hide the CTA button on flows where the user is already committed / mid-flow
const HIDE_CTA_ON = [/^\/checkout/, /^\/payment\//, /^\/assessment\//, /^\/results\//];

export default function SiteHeader() {
  const { pathname, search } = useLocation();
  if (new URLSearchParams(search).get("print") === "1") return null;
  const hideCTA = HIDE_CTA_ON.some((re) => re.test(pathname));
  const linkCls = ({ isActive }) =>
    `eyebrow px-3 py-2 ${isActive ? "text-[#1A1915] border-b border-[#1A1915]" : "text-[#78716C] hover:text-[#1A1915]"}`;
  return (
    <header className="sticky top-0 z-40 bg-[#FAFAF9]/90 backdrop-blur-md border-b border-[#1A1915]/15">
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 py-4">
        <Link to="/" className="flex items-center" data-testid="header-logo-link">
          <Logo variant="horizontal" className="h-7 md:h-8 w-auto" />
        </Link>
        <nav className="hidden md:flex items-center gap-2" data-testid="header-nav">
          <NavLink to="/preview" className={linkCls} data-testid="nav-preview">Preview</NavLink>
          <NavLink to="/model" className={linkCls} data-testid="nav-model">Model</NavLink>
          <NavLink to="/lessons" className={linkCls} data-testid="nav-lessons">Lessons</NavLink>
        </nav>
        {hideCTA ? (
          <span aria-hidden="true" className="w-[1px]" />
        ) : (
          <Link
            to="/checkout"
            className="btn-primary text-xs px-3 sm:px-6 whitespace-nowrap"
            data-testid="header-cta"
            onClick={() => trackCta("header_sticky")}
          >
            <span className="hidden sm:inline">Show me my bottleneck · </span>
            <span className="sm:hidden">Diagnose · </span>
            $97
          </Link>
        )}
      </div>
    </header>
  );
}
